import { FC } from 'react'
import { generateSrcSet } from 'project/image-proxy-web'
import SubscriptionPricing from 'components/SubscriptionPricing'
import useWindowSize from 'components/util/useWindowSize'
import { TPlanSummary } from 'common/cms-types'
import { PlanSlug } from 'common/planSlugs'
import { ButtonType } from 'types/global'
import { Tenant } from 'common/tenant'

const MEDIA = {
  desktop: {
    src: '/images/new/robot-pointing-right.png',
    width: 818,
    height: 717,
  },
  mobile: {
    src: '/images/new/robot-holding-mail.png',
    width: 393,
    height: 507,
  },
} as const

interface NoSetupFeesSectionProps {
  plans: TPlanSummary[]
  tenant?: Tenant
}

const NoSetupFeesSection: FC<NoSetupFeesSectionProps> = ({
  plans,
  tenant = Tenant.UK,
}) => {
  const { isLgOrHigher } = useWindowSize()
  const media = isLgOrHigher ? MEDIA.desktop : MEDIA.mobile
  const scanLitePlan = plans?.find((p) => p.slug === PlanSlug.SCAN_LITE)

  return (
    <div>
      <h2 className='fs-fluid-48-80 lh-105 text-center'>
        <span className='color-pink2'>No setup or handling fees! </span>
        <br />– Not even hidden ones.
      </h2>
      <div className='d-flex flex-lg-row flex-column align-items-center'>
        <div style={isLgOrHigher ? { maxWidth: '60%' } : {}}>
          <img
            {...generateSrcSet(media.src, media.width, media.height)}
            loading='lazy'
            className='img-fluid'
            height={media.height}
            width={media.width}
            alt={isLgOrHigher ? 'HaiRo™ pointing right' : 'HaiRo™ holding mail'}
          />
        </div>
        {scanLitePlan && (
          <div className='flex-1 align-self-start mt-lg-25'>
            <SubscriptionPricing
              planSummary={scanLitePlan}
              className='me-xl-20'
              buttonType={ButtonType.HOMEPAGE_NO_FEES_CTA}
              buttonAlign='start'
              tenant={tenant}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default NoSetupFeesSection
